/**
 * Injects the Meta (Facebook) Pixel, but only where a pixel id is configured.
 *
 * Gated exactly like `useGoogleAnalytics()`: the id comes from
 * `runtimeConfig.public.metaPixelId`, set per environment by
 * `NUXT_PUBLIC_META_PIXEL_ID`. Production sets it; staging and local leave it
 * unset, so no tag is emitted and connect.facebook.net is never contacted.
 * See `useGoogleAnalytics()` for why this can't live in `app.head`.
 *
 * The `<noscript>` image beacon from Meta's snippet is included so visitors
 * with JavaScript disabled still register a PageView.
 */
export function useMetaPixel(): void {
  const pixelId = useRuntimeConfig().public.metaPixelId;

  if (!pixelId) return;

  useHead({
    script: [
      {
        innerHTML: `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', ${JSON.stringify(pixelId)});
fbq('track', 'PageView');`,
      },
    ],
    noscript: [
      {
        innerHTML: `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${encodeURIComponent(pixelId)}&ev=PageView&noscript=1" />`,
      },
    ],
  });
}
